<template>
  <li class="home-timeline-item">
   <div class="home-timeline-item__tail"></div>
	 
   <div class="home-timeline-item__node"></div>
	 
   <div class="home-timeline-item__wrapper">
		 
   	<div class="home-timeline-item__timestamp is-left">
   		15秒前
   	</div>
		
   	<div class="home-timeline-item__content">
   		<!-- 可用slot -->
   		<div class="slote">
   			<div class="lay flex_start">
   				<img src="~assets/base/small_rentou.png" />
   				<span>XX</span>
   				专职律师
   			</div>
   			<!-- <div :class="{actvcolor:isacolor}">{{`你好！请问男方服刑时间长，女方可以提出离婚` | toEllipsisFilter(spl)}}</div> -->
			<div class="ellipsis">
				你好！请问男方服刑时间长，女方可以提出离婚
			</div>
   			<div class="answer ellipsis"><span>问题分析：</span> 可以的。</div>
   		</div>
   		<!-- 可用slot -->
   
   	</div>
   
   </div>
  </li>
</template>

<script>
  export default {
    name: 'homeTimeline',
		props: {
			spl: Number,
			isacolor:{
				type:Boolean,
				default:false
			}
		},

  };
</script>
<style lang="scss" scoped>
	.home-timeline-item {
		width: 100%;
		position: relative;
		text-align: left;
	}

	.home-timeline-item:hover {
		.home-timeline-item__timestamp {
			color: #333;
		}

		.home-timeline-item__node {
			background-color: #0465ea;
		}

		.home-timeline-item__content {
			background-color: #fff;
			box-shadow: 0px 1px 7px 0px rgba(0, 0, 0, 0.05);

		}
		.actvcolor{
			color: #0465EA;
		}
	}
	

	.home-timeline-item__timestamp.is-left {
		position: absolute;
		top: 10px;
		left: 4px;
	}

	.home-timeline-item__tail {
		position: absolute;
		top: 10px;
		left: 70px;
		height: 100%;
		border-right: 1px solid #ccc;
	}
	
	.home-timeline-item__node {
		position: absolute;
		top: 10px;
		left: 59px;
		z-index: 1;
		transform: translateX(50%);
		width: 12px;
		height: 12px;
		border-radius: 50%;
		background-color: #ccc;


	}

	.home-timeline-item__wrapper {
		padding-left: 96px;
	}

	.home-timeline-item__content {
		color: #666666;
		padding: 12px 23px 22px;
	}

	.home-timeline-item__timestamp {
		color: #909399;
		line-height: 1;
		font-size: 16px;
	}

	.slote {
		.lay {
			margin-bottom: 10px;

			img {
				width: 40px;
				height: 40px;
			}

			span {
				font-size: 20px;
				color: #333;
				margin: 0 10px;
			}
		}

		.answer {
			margin-top: 6px;
			span {
				color: #999;
			}
		}
		
	}
</style>

